module.exports = __webpack_public_path__ + "img/seloMedalhaOuroSombra.8434b09b.png";